const HOSTILE_DOMAINS = ["inspiration-grid.com", "www.inspiration-grid.com"]

const shouldBlankHostileDomain = hostname =>
  typeof hostname === "string" && HOSTILE_DOMAINS.includes(hostname)

const blankHostileDomain = () => {
  if (
    typeof window === "undefined" ||
    !shouldBlankHostileDomain(window.location.hostname)
  ) {
    return
  }

  console.log(
    "Inspiration Grid copied-site guard active for inspiration-grid.com"
  )

  const addNoindexMeta = () => {
    if (!document.head) {
      return
    }

    const meta = document.createElement("meta")
    meta.name = "robots"
    meta.content = "noindex,nofollow,noarchive,nosnippet"
    document.head.appendChild(meta)
  }

  const blankDocument = () => {
    if (document.body) {
      document.body.innerHTML = ""
    }
  }

  addNoindexMeta()
  blankDocument()
  window.setTimeout(blankDocument, 0)
}

module.exports = {
  HOSTILE_DOMAINS,
  shouldBlankHostileDomain,
  blankHostileDomain,
}
